import React from 'react';
import SeminarClinicFormFields from './SeminarClinicFormFields';
import { FormErrors } from '@chiroup/core/types/ErrorResponse.type';
import { SeminarSignupForm } from '@chiroup/core/types/Seminar.type';
import { ValueOf } from '@visx/scale';

type Props = {
  value: Partial<SeminarSignupForm>;
  onChange: (
    key: keyof Partial<SeminarSignupForm>,
  ) => (val: ValueOf<SeminarSignupForm>) => void;
  errors?: FormErrors;
  isSubmitting: boolean;
  setCreateClinic: React.Dispatch<React.SetStateAction<boolean>>;
};
const SeminarCreateNewClinic: React.FC<Props> = ({
  value,
  onChange,
  errors,
  isSubmitting,
  setCreateClinic,
}) => {
  return (
    <SeminarClinicFormFields
      onChange={onChange}
      value={value}
      errors={errors}
    />
  );
};

export default SeminarCreateNewClinic;
